



























import Vue, { PropType } from 'vue';
import { MaterialsBlock, MaterialsBlockItem } from './types';

export default Vue.extend({
    props: {
        data: Object as PropType<MaterialsBlock>,
    },

    computed: {
        image(): MaterialsBlock['image'] {
            return this.data.image;
        },

        items(): MaterialsBlockItem[] {
            return this.data.items;
        },
    },
});
